module.exports = __webpack_public_path__ + "static/media/company_Holiday.9b033c4c.png";